<div [formGroup]="parent">
  <div class="form-group has-float-label" formGroupName="orderHeader">
    <label class="form-label"
      >Client/Prospect#<span class="madatory-field">*</span></label
    >
    <input
      #customerAccountInputElt
      autocomplete="off"
      pInputText
      jniAutoCompleteBlocker
      type="text"
      id="customerAccount"
      name="customerAccount"
      class="form-control"
      [value]="customerAccountNumber"
      formControlName="customerIdValid"
      (input)="customerVendor$.next($any($event.target).value)"
      (keyup)="
        onCustomerSearchOpenToggle(
          customerAccountPopOver,
          $event,
          customerAccountInputElt
        )
      "
      (keydown.Tab)="getCustomerAccount($event, customerAccountPopOver)"
      [ngClass]="{ 'has-error': formErrors['customerIdValid'] }"
      (blur)="logValidationErrors()" />

    <span class="error-msg" *ngIf="formErrors['customerIdValid']">
      {{ formErrors["customerIdValid"] }}
    </span>
  </div>
  <p-popover
    class="order-dropdown add"
    #customerAccountPopOver
    aria-labelledby="dropdownBasic1">
    <!-- <p-scroller style="height: 200px"> -->
    <p-table
      #dt
      stripedRows
      [size]="'small'"
      [value]="customerLists"
      styleClass="p-datatable-customers order-listing"
      [rowHover]="true"
      [rows]="10"
      [resizableColumns]="true"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="false"
      [filterDelay]="0"
      [scrollable]="true"
      sortMode="multiple"
      styleClass="table-listing"
      [scrollHeight]="'330px'">
      <ng-template pTemplate="header">
        <tr class="table-head">
          <th class="name">Name</th>
          <th class="vaccount">Client Account</th>
          <th class="street" style="width: 100px" pSortableColumn="street">
            Street
            <p-sortIcon field="street"></p-sortIcon>
          </th>
          <th class="city" pSortableColumn="city">
            City
            <p-sortIcon field="city"></p-sortIcon>
          </th>
          <th class="state" pSortableColumn="state">
            State
            <p-sortIcon field="state"></p-sortIcon>
          </th>
          <th class="state max-width-7" pSortableColumn="billingAttentionD365">
            Attention
            <p-sortIcon field="billingAttentionD365"></p-sortIcon>
          </th>
          <th class="country max-width-7">Last order date</th>
        </tr>

        <tr>
          <th></th>
          <th></th>
          <th>
            <div class="d-flex">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="street"
                id="street"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'street', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="city"
                id="city"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'city', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="state"
                id="state"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'state', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>

          <th class="max-width-7">
            <div class="d-flex">
              <input
                pInputText
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="billingAttentionD365"
                id="billingAttentionD365"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'billingAttentionD365',
                    'contains'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>

          <th class="max-width-7"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-customerList let-rowIndex="rowIndex">
        <tr
          class="p-selectable-row mousepointer"
          (click)="onClientSelection(customerList, customerAccountPopOver)">
          <td class="name mousepointer">
            {{ customerList.organizationNameD365 }}
          </td>
          <td class="vaccount mousepointer">
            {{ customerList.clientAccount }}
          </td>
          <td style="width: 200px" class="sname mousepointer">
            {{ customerList.street }}
          </td>
          <td class="city mousepointer">{{ customerList.city }}</td>
          <td style="width: 72px" class="state mousepointer">
            {{ customerList.state }}
          </td>
          <td style="width: 72px" class="state mousepointer">
            {{ customerList.billingAttentionD365 }}
          </td>
          <td style="width: 75px" class="country mousepointer">
            {{ customerList.lastOrderDate | date: "yyyy-MM-dd" }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20">No client found.</td>
        </tr>
      </ng-template>
    </p-table>
    <!-- </p-scroller> -->
  </p-popover>
</div>
